import React from 'react';
import { useState } from 'react';
import Homepage from '../pages/Homepage';
import Report from '../pages/Report';
import WWA from '../pages/WWA.jsx';
import WWO from '../pages/WWO.jsx';
import FAQ from '../pages/FAQ.jsx';
import News from '../pages/News.jsx';
import Article1 from '../pages/Article1.jsx';
import Article2 from '../pages/Article2.jsx';
import Article3 from '../pages/Article3.jsx';
import Contact from '../pages/Contact.jsx';
import Terms from '../pages/Terms.jsx';
import Privacy from '../pages/Privacy.jsx';
import Loader from './Loader.jsx';
import withScrollToTop from '../components/withScrollToTop.jsx';
import { hasLoaderPlayed, markLoaderPlayed } from './loaderReady.js';

import { AnimatePresence } from 'framer-motion';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Built once at module scope on purpose: creating these inside the component would
// hand React a new component type on every render, tearing down and rebuilding the
// whole page (a white flash) every time `loading` changes.
const HomepageL = withScrollToTop(Homepage);
const FAQL = withScrollToTop(FAQ);
const WWAL = withScrollToTop(WWA);
const WWOL = withScrollToTop(WWO);
const NewsL = withScrollToTop(News);
const ContactL = withScrollToTop(Contact);
const ReportL = withScrollToTop(Report);
const Article1L = withScrollToTop(Article1);
const Article2L = withScrollToTop(Article2);
const Article3L = withScrollToTop(Article3);
const TermsL = withScrollToTop(Terms);
const PrivacyL = withScrollToTop(Privacy);

const AnimatedRoutes = () => {


  const [loading, setLoading] = useState(() => !hasLoaderPlayed());

  const finishLoading = () => {
     markLoaderPlayed();
     setLoading(false);
  };

   const location = useLocation();

   return (
      <>
         {loading && <Loader setLoading={finishLoading} />}
         <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
               <Route path="/" element={<HomepageL />} />
               <Route path="/home" element={<HomepageL />} />
               <Route path="/faq" element={<FAQL />} />
               <Route path="/news" element={<NewsL />} />
               <Route path="/terms" element={<TermsL />} />
               <Route path="/privacy" element={<PrivacyL />} />
               <Route path="/article1" element={<Article1L />} />

               <Route path="/load" element={<Loader />} />
               <Route path="/article2" element={<Article2L />} />

               <Route path="/article3" element={<Article3L />} />
               <Route path="/contact" element={<ContactL />} />
               <Route path="/what-we-offer" element={<WWOL />} />
               <Route path="/financial-report" element={<ReportL />} />
               <Route path="/who-we-are" element={<WWAL />} />
               <Route path="*" element={<Navigate to="/" />} />
            </Routes>
         </AnimatePresence>
      </>
   )
}

export default AnimatedRoutes